<!-- 有修正要檢查同步改到 jkaggrid.component.html -->

<div class="w-full" [cdkContextMenuTriggerFor]="context_menu">
  <ag-grid-angular #myGrid [theme]="gridSrv.theme" [ngStyle]="gridStyle" [columnDefs]="columnDefs"
    [columnTypes]="gridSrv.columnTypes" [defaultColDef]="defaultColDef" [localeText]="gridSrv.localeText"
    [pagination]="gridSrv.pagination" [paginationPageSize]="gridSrv.paginationPageSize"
    [paginationPageSizeSelector]="gridSrv.paginationPageSizeSelector" [rowSelection]="gridSrv.rowSelection"
    [rowData]="itemList" (gridReady)="onGridReady($event)" (keydown)="onKeydown($event)"
    (rowClicked)="onRowClicked($event)" (rowDoubleClicked)="onRowDoubleClicked($event)" [editType]="'fullRow'"
    [enableBrowserTooltips]="true" (cellValueChanged)="onCellValueChanged($event)" (rowSelected)="onRowSelected($event)"
    (onSelectionChanged)="onSelectionChanged()">
  </ag-grid-angular>

</div>
<ng-template #context_menu>
  <div class="jk-menu" cdkMenu>
    @if(isJkaggrid){
    <button class="jk-menu-item" cdkMenuItem (click)="doUIEdit()">修改</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doUIInsert()">新增</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doUIDelete()">刪除</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doSetup()">管理員設定</button>
    <div class="jk-menu-divider"></div>
    }
    <button class="jk-menu-item" cdkMenuItem (click)="doFilter('')">過濾條件</button>
    <button class="jk-menu-item" cdkMenuItem (click)="reloadGrid()">重新整理</button>
    <button class="jk-menu-item" cdkMenuItem>取消功能表</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doItemList()">資料內容(json)</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doMyExportExcel(itemList)">匯出Excel(xlsx)</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doSaveTitle(columnDefs)">存欄位設定</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doResetTitle()">重置欄位設定</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doShowManagerField(columnDefs)">顯示管理欄位</button>
  </div>
</ng-template>
